export const ROUTES = {
  users: {
    path: '/users',
    fullPath: '/users/:id?',
    roles: {
      path: '/roles',
      fullPath: '/roles'
    }
  },

  roles: {
    path: '/roles',
    fullPath: '/roles/:id?'
  },

  filials: {
    path: '/organizations',
    fullPath: '/organizations/:id?',
    edit: {
      path: 'edit/:id',
      fullPath: '/organizations/edit/:id',
      clearPath: '/organizations/edit',
      pages: {
        common: {
          settings: '',
          security: 'security',
          smtp: 'smtp',
          importUsers: 'import-users',
          mailServers: 'mail-servers',
          mailingSetup: 'mailing-setup',
          locale: 'locale',
          diskSpace: 'disk-space'
        },
        subRoutes: {
          quotas: {
            path: 'quotas',
            fullPath: 'disk-space/quotas'
          }
        },
        auth: {
          ldap: 'ldap',
          invite: 'invite'
        },
        modules: {
          // drive: 'drive',
          email: 'email',
          calendar: 'calendar',
          draw: 'draw',
          contacts: 'contacts',
          projects: 'projects',
          pages: 'pages',
          forms: 'forms'
        }
      }
    }
  },

  profile: {
    path: '/profile',
    fullPath: '/profile/:id',
    pages: {
      personalData: '',
      filials: 'filials',
      safety: 'safety',
      mailAccount: 'mail-account',
      disk: 'disk',
      licenses: 'licenses',
      locale: 'locale',
      notifications: 'notifications',
      notificationSettings: 'notification-settings'
    }
  },

  dashboard: {
    fullPath: '/dashboard'
  },

  home: {
    fullPath: '/home'
  },

  statistics: {
    path: '/statistics',
    fullPath: '/statistics',
    links: {
      activity: '',
      diskSpace: 'disk-space',
      audit: 'audit'
    }
  },
  commonSettings: {
    path: '/settings',
    fullPath: '/settings',
    pages: {
      branding: 'branding',
      customisation: 'customisation',
      auditTrail: 'trail',
      integrations: '',
      notifications: 'notifications'
    }
  },
  activations: {
    path: '/activations',
    fullPath: '/activations'
  },

  subscriptions: {
    path: ' subscriptions',
    fullPath: '/subscriptions'
  }
};
